import { render, staticRenderFns } from "./divarNews.vue?vue&type=template&id=46539ced&scoped=true"
import script from "./divarNews.vue?vue&type=script&lang=js"
export * from "./divarNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46539ced",
  null
  
)

export default component.exports